module.exports = __webpack_public_path__ + "static/img/Emo_Write_Web_2.da14b57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/jobScreenShot/Emo_Write_Web_2.jpg
// module id = BcEp
// module chunks = 0